export const meta = {
	title: "JavaScript"
};

# JavaScript
[**JavaScript**](https://developer.mozilla.org/en-US/docs/Web/JavaScript) is a programming language.

<Callout type="warning"><Definition term="javascript" /> is VERY evil</Callout>

- Each definition is 
- an MDX file
